export default __webpack_public_path__ + "static/media/checked_light.df4bd98e.svg";